"use client";
import { useTranslations } from "next-intl";
import CuttingInfo, {
  Cutting,
  formatCutting,
} from "../../portal/components/products/CuttingInfo";
import Button from "../../theme/components/Button";

export default function ProductCutting({
  cutting,
  onClick,
}: {
  cutting: Cutting;
  onClick?: any;
}) {
  const t = useTranslations();

  return (
    <div className="product-detail-cutting position-relative mt-4">
      <CuttingInfo cutting={cutting} />
      <div className="border border-style-dashed border-radius px-4 py-4 d-flex gap-4 align-items-center">
        <Button
          className="flex-shrink-0"
          appearance="secondary"
          icon="cut"
          onClick={onClick}
        >
          {t("cutting_selected")}
        </Button>
        <div>{formatCutting(t, cutting, true)}</div>
      </div>
    </div>
  );
}
